import React, { createContext, useState } from "react";

export const SearchCompetitorContext = createContext({});

export const initialSearchValues = {
  countryId: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  sortBy: "createDate",
  sortDirection: "DESC",
};

const SearchCompetitorProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchCompetitorContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchCompetitorContext.Provider>
  );
};

export default SearchCompetitorProvider;
